<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="hideFilters = !hideFilters"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="
                hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
              "
            />
          </div>
          <!-- General searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              color="grey-5"
              :disable="!hideFilters"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.logs.list.filter.label')"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
      <div v-if="!hideFilters" class="table-block q-mb-md">
        <div
          class="row q-pt-md q-pl-md q-pr-md"
          style="justify-content: space-between"
        >
          <!-- Select field -->
          <div class="col-6 q-pb-md q-pl-md q-pr-md">
            <q-select
              @input="applyFilters"
              v-model="filters.level"
              :options="levelOptions"
              :float-label="getString('module.logs.list.table.column.level')"
            />
          </div>
          <!-- Inputfield -->
          <div class="col-6 q-pl-md q-pr-md">
            <q-input
              color="primary"
              v-model="filters.general"
              @input="applyFilters"
              :float-label="getString(null, 'Search in message, reference or item code', 'Zoeken in bericht, referentie of itemcode')"
            />
          </div>
        </div>
        <!-- Button to reset fields -->
        <div class="row q-pl-md q-pr-md" style="justify-content: flex-end">
          <div class="q-pl-md q-pr-md q-pb-md" style="vertical-align: middle">
            <q-btn
              :disable="!activeFilters"
              @click="resetFilters()"
              class="capitalize ctrl-button"
              :color="activeFilters ? 'primary' : 'grey-4'"
              label="Reset"
            />
          </div>
        </div>
      </div>
    </transition>

    <!-- Data table -->
    <table-overview
      v-if="responseData.multiple"
      :endpoint="endpoint"
      :responseFormat="responseFormat"
      :columns="columns"
      :permission="permission"
      :module="module"
      :customEvents="true"
      :selectable="false"
      :highlight-fields="highlightFields"
    >
    </table-overview>
  </div>
</template>

<script>
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';
import common from './common';

export default {
  mixins: [common, filtersMixin],
  components: {
    TableOverview,
  },
  data() {
    return {
      highlightFields: ['message'],
      rowSelection: [],
      isLoading: false,
      searchTerm: '',
      filters: {
        level: [],
        general: '',
      },
      levelOptions: [
        {
          label: 'Info',
          value: 'info',
        },
        {
          label: 'Error',
          value: 'error',
        },
      ],
      columns: [
        {
          name: '__slot:level',
          title: this.getString('module.logs.list.table.column.level'),
          sortField: 'level',
          titleClass: 'text-left sortable vcol-xs',
          dataClass: 'text-left vcol-xs text-ellipsis',
        },
        {
          name: '__slot:spareparts-reference',
          title: this.getString(null, 'Reference', 'Referentie'),
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: '__slot:sp-item-code',
          title: this.getString(null, 'Item Code', 'Itemcode'),
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: '__slot:message',
          title: this.getString('module.logs.list.table.column.message'),
          sortField: 'message',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: 'created_at',
          title: this.getString(null, 'Created at', 'Aangemaakt op'),
          callback: 'tableFormatTime',
          titleClass: 'text-left vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
      ],
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
